<script lang="ts">
    export let active: boolean

    export let clicked: Function

    function click() {
		active = !active
		clicked(active)
	}
</script>

<!-- Not toggled switch -->
<div class="w-full h-full flex flex-col justify-center items-center cursor-pointer" on:click={click}>
    <div class="flex justify-center items-center font-semibold">
        <span class="">
            Nincs forgatás
        </span>

            {#if active === true}
                <!-- Switch Container -->
                <div class="w-14 h-7 flex items-center bg-gray-400 rounded-full mx-3 px-1 bg-blue-700">
                    <!-- Switch -->
                    <div class="bg-white w-5 h-5 rounded-full shadow-md transform translate-x-7"></div>
                </div>
            {:else}
                <div class="w-14 h-7 flex items-center bg-gray-400 rounded-full mx-3 px-1">
                    <!-- Switch -->
                    <div class="bg-white w-5 h-5 rounded-full shadow-md transform"></div>
                </div>
            {/if}

        <span class="">
            Forgatás
        </span>
    </div>
<!--     Toggled switch -->
</div>